import { faHouse } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import VoxelAlert from '../../components/voxel/Alert/VoxelAlert';
import VoxelButton from '../../components/voxel/Buttons/VoxelButton';
import VoxelButtonGrid from '../../components/voxel/Buttons/VoxelButtonGrid';
import VoxelPageContainer from '../../components/voxel/Containers/VoxelPageContainer';
import { useHistory } from 'react-router';
import { TeamMenuChoices } from '../TeamPage/TeamPage';

export interface StripeCheckoutCanceledProps {}

export const StripeCheckoutCanceled: React.FC<StripeCheckoutCanceledProps> = ({}) => {
  const history = useHistory();
  const subscriptionPage = '/team/' + TeamMenuChoices.Subscription;
  const goToSubscriptionPage = () => history.push(subscriptionPage);

  return (
    <VoxelPageContainer>
      <VoxelAlert severity="warning" title="Checkout canceled">
        Go through the same process again if you wish to checkout
      </VoxelAlert>

      <div className="h-8" />

      <VoxelButtonGrid>
        <VoxelButton
          title="Go to subscription page"
          startIcon={<FontAwesomeIcon icon={faHouse} />}
          onClick={goToSubscriptionPage}
        />
      </VoxelButtonGrid>
    </VoxelPageContainer>
  );
};

export default StripeCheckoutCanceled;
